<div class="report-schedule" #timeDiv>
  <div class="report-schedule-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p d-flex">
        <div class="part-description p-relative font-600 font-20">{{title}}</div>
        <!-- <div class="d-flex ml-auto align-items-center"> -->
          <!-- <app-switch-pill class="mr-2" *ngIf="isMidasRoyaltyReportsEnable && isRoyaltyReport && showXMLToggle" position="end" label="Send XML to FTP"
            [isActive]="isXMLSendToFTP" [disabled]="!isSupportUser"
            (appChange)="handleSwitchChange($event)"></app-switch-pill>
          <i id="part-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i> -->
      <!-- </div> -->
      </div>
    </div>
  </div>

  <!-- body -->
  <div class="report-schedule-body border-bottom-light">
    <div class="ui-g-12 p-0 font-16 font-400">
      <p>
        {{subTitle}}
      </p>
    </div>
    <div class="mb-4 w-100">
      <div class="ui-g-12 p-0 mb-3">
        <!-- Frequency of sending report -->
        <div class="ui-g-6 p-0" [ngClass]="{'disabled' :type === 'royaltyReport'}">
          <label class="font-14 font-600 mb-1">
            <span class="font-gray-500">Frequency of sending report*</span>
            <span class="ml-2">
              <i [pTooltip]="tooltip" tooltipPosition="top" tooltipStyleClass="report-schedule-tooltip" class="flex-start-center pointer" class="fa fa-info-circle"></i>
            </span>
          </label>

          <app-dropdown
            placeholder="Select"
            theme="border"
            position="bottom"
            field="name"
            scrollHeight="200px"
            id="frequency-selection"
            listId="frequency-selection-list"
            [fontSize]="14"
            [setPositionDynamically]="true"
            [disabled]="type === 'royaltyReport'"
            [options]="scheduleList"
            [isDropdownIconVisible]="true"
            [value]="selectedValue"
            (appSelect)="onSelect($event, 'frequency')"
          >
          </app-dropdown>
        </div>

        <!-- Date of the year -->
        <div class="ui-g-6 py-0" *ngIf="frequencyType === 'weekly'">
          <label class="font-12 font-600 mb-1">
            <span>Day of the week*</span>
          </label>

          <app-dropdown
            placeholder="Select"
            theme="border"
            position="bottom"
            field="name"
            scrollHeight="200px"
            id="frequanc-selection"
            listId="frequanc-selection-list"
            [fontSize]="14"
            [setPositionDynamically]="false"
            [options]="weekDays"
            [isDropdownIconVisible]="true"
            [value]="day"
            (appSelect)="onSelect($event, 'weekday')"
          >
          </app-dropdown>
        </div>

        <!-- Day of the Month/Year -->
        <div class="ui-g-6 py-0" *ngIf="frequencyType === 'monthly'" 
        [ngClass]="{'disabled' :type === 'royaltyReport'}"
        >
          <label class="font-14 font-600 mb-1">
            <span class="font-gray-500">Day of the month*</span>
          </label>
          <app-dropdown
            placeholder="Select"
            theme="border"
            position="bottom"
            field="name"
            scrollHeight="200px"
            id="frequency-selection"
            listId="frequency-selection-list"
            [fontSize]="14"
            [setPositionDynamically]="true"
            [disabled]="type === 'royaltyReport'"
            [options]="monthlyOptions"
            [isDropdownIconVisible]="true"
            [value]="month"
            [hasCustomItemTemplate]="true"
            (appSelect)="onSelect($event, 'monthly')"
          >
          <ng-template let-item appTemplate="item">
            <div class="ui-g p-0">
              <div class="ui-g-12 p-0 flex-start-start">
                <div class="flex-column font-12">
                  <span class="font-12 font-secondary-700">
                    <span>
                      {{ item?.label }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
          </app-dropdown>
        </div>

        <div class="ui-g-6 add-payment py-0" *ngIf="frequencyType === 'annually'">
          <label class="font-14 font-600 mb-1">
            <span class="font-gray-500">Day of the year*</span>
          </label>
          <div class="calendar-input flex-between-center payment-date pointer">
            <p-calendar
              id="frequency-yearly-date"
              styleClass="payment-pointer"
              placeholder="Date"
              [(ngModel)]="selectedDate"
              [readonlyInput]="true"
              dateFormat="dd 'of' MM"
              (onSelect)="onDateTimeChange($event, annually)"
              #paymentDateTimeEl
              [baseZIndex]="9999"
              appendTo="body"
            ></p-calendar>
            
            <i class="fal fa-chevron-down" (click)="paymentDateTimeEl.showOverlay()"></i>
          </div>
        </div>

        <!-- Send reports  -->
        <div class="ui-g-12 pl-0">
          <label class="font-12 font-600 mb-1">
            <span class="font-gray-500">{{userPlaceholder}}</span>
          </label>
          <!-- customer list and tags -->
          <div class="ui-g-12 estimate-customer position-relative border-bottom-lightest p-0">
            <div class="tag-pill-list flex-start-center flex-wrap">
              <div class="tag-pill pl-3" *ngFor="let term of selectedCustomers; let i = index">
                <span class="mr-1 font-gray-800 font-600">{{ term }} &nbsp;</span>
                <i class="fal fa-times pointer font-gray-800 font-600 mr-2" (click)="handleRemoveFilter('searchTerms', term, i)"></i>
              </div>
            </div>
            <app-auto-complete
              id="ac-gloabal-search-customer-list1"
              listId="ac-gloabal-search-customer-list1"
              name="schedule-customer"
              placeholder="Type email here"
              theme="border"
              scrollHeight="237px"
              inactiveItemsKey="isActive"
              styleClassInput="text-ellipse"
              [suggestions]="customerSearchResults"
              [closeOnSelection]="true"
              [hasEditableField]="false"
              [fontSize]="14"
              [showDisabledIcon]="false"
              [hasSearchIcon]="true"
              [value]="selectItem"
              [isLoading]="isLoading"
              [autoFocus]="false"
              (appSelect)="onCustomerSelect($event)"
              (appCompletedMethod)="customerSearch($event)"
              (appChange)="onCustomerSearchChange($event)"
              (appClear)="onSearchClear()"
            >
              <ng-template let-item appTemplate="static">
                <div id="est-add-customer" class="font-primary p-1 flex-start-center" (click)="onAddEmailSelect(customerSearchData);">
                  <i class="fal fa-plus pr-2 mr-1"></i>
                  <span class="font-12 pointer hover-underline">Add email</span>
                </div>
              </ng-template>

              <ng-template let-item appTemplate="item">
                <div class="ui-g p-0 search-item"  (click)="onCustomerSelect($event)">
                  <div class="ui-g-12 flex-start-start p-0">
                    <div class="flex-column p-1 width-100p">
                      <div class="flex-between-center">
                        <div>
                          <span class="font-12 font-600 font-gray-700">{{ item?.firstName }} {{ item?.lastName }}</span>
                          <br />
                          <span class="font-12 font-400 font-gray-400">{{ item?.email }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
      </div>
    </div>
    <!-- body end -->

    <!-- Star Footer -->
    <div class="ui-g-12 flex-between-end dialog-footer part-footer border-top">
      <div class="report-schedule-dialog-footer d-flex justify-content-end width-100p">
        <div>
          <button id="part-cancel-btn" class="btn btn-white btn-border pointer btn-submit mr-1" (click)="closeDialog()">Cancel</button>

          <button id="part-save-btn" class="btn btn-primary btn-submit pointer" [disabled]="isInvalid  || isLoading" (click)="onSubmit()">
            <span [ngClass]="{ 'pr-2': isLoading }">Save</span>
            <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- End Add Parts Footer -->
  </div>
</div>
